import { NgModule, LOCALE_ID, APP_INITIALIZER } from '@angular/core';
import { registerLocaleData } from '@angular/common';
import * as fr from '@angular/common/locales/fr';
import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import {
  CommonModule,
  HashLocationStrategy,
  LocationStrategy,
} from '@angular/common';
import { MatCardModule } from '@angular/material/card';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatDialogModule } from '@angular/material/dialog';

import { AuthModule } from './modules/auth/auth.module';
import { UtilisateursModule } from './modules/utilisateurs/utilisateurs.module';
import { SharedModule } from './modules/shared/shared.module';
import { AppelsModule } from './modules/appels/appels.module';
import { AgendaModule } from './modules/agenda/agenda.module';
import { BibliothequeModule } from './modules/bibliotheque/bibliotheque.module';
import { ELearningModule } from './modules/e-learning/e-learning.module';
import { NotFoundComponent } from './components/not-found/not-found.component';
import { FormAppelComponent } from './components/form-appel/form-appel.component';
import { MatRadioModule } from '@angular/material/radio';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { ListeUserComponent } from './modules/utilisateurs/components/liste-user/liste-user.component';
import { KeycloakAngularModule, KeycloakService } from 'keycloak-angular';
import { initializer } from './utils/app-init';
import { RequestInterceptorService } from './service/interceptors/request-interceptor.service';
import { SuccessCandidatureComponent } from './components/success-candidature/success-candidature.component';

import { StemdFormComponent } from './components/stemd-form/stemd-form.component';
import { InviteFormComponent } from './components/invite-form/invite-form.component';
import { FormAppelOneFamilyComponent } from './components/form-appel-one-family/form-appel-one-family.component';
import { BilcompComponent } from './modules/ppp/components/bilancomp/bilcomp/bilcomp.component';
import { ExpmarcheComponent } from './modules/ppp/components/expmarche/expmarche/expmarche.component';
import { DecrealComponent } from './modules/ppp/components/decreal/decreal/decreal.component';
import { FinalpppComponent } from './modules/ppp/components/finalppp/finalppp/finalppp.component';
import { ConfirmationHorsParcoursComponent } from './components/confirmation-hors-parcours/confirmation-hors-parcours.component';
import { FormAppelHorsParcoursComponent } from './components/form-appel-hors-parcours/form-appel-hors-parcours.component';
import { MatPaginatorModule } from '@angular/material/paginator';
import { FormMultiAppelComponent } from './components/form-multi-appel/form-multi-appel.component';
import { FormAppelImprovedComponent } from './components/form-appel-improved/form-appel-improved.component';
import { MiniJpoFormComponent } from './components/mini-jpo-form/mini-jpo-form.component';
import { JpoFormComponent } from './components/jpo-form/jpo-form.component';
import { ActivityConfirmationFormComponent } from './components/activity-confirmation-form/activity-confirmation-form.component';
import { ActivityQrcodeConfirmationFormComponent } from './components/activity-qrcode-confirmation-form/activity-qrcode-confirmation-form.component';
import { FormationFormComponent } from './components/formation-commercants-form/formation-form.component';
import { PortailappelformComponent } from './components/portailappelform/portailappelform.component';
import { FormAppelImprovedCdpComponent } from './components/form-appel-improved-cdp/form-appel-improved-cdp.component';
import { FormMultiAppelCdpComponent } from './components/form-multi-appel-cdp/form-multi-appel-cdp.component';
import { BootcampConfirmationComponent } from './components/bootcamp-confirmation/bootcamp-confirmation.component';
import { ActivityAttendanceComponent } from './components/activity-attendance/activity-attendance.component';

@NgModule({
  declarations: [
    AppComponent,
    NotFoundComponent,
    FormAppelComponent,
    ListeUserComponent,
    SuccessCandidatureComponent,
    StemdFormComponent,
    InviteFormComponent,
    FormAppelOneFamilyComponent,
    ConfirmationHorsParcoursComponent,
    FormAppelHorsParcoursComponent,
    FormMultiAppelComponent,
    FormAppelImprovedComponent,
    MiniJpoFormComponent,
    JpoFormComponent,
    ActivityConfirmationFormComponent,
    ActivityQrcodeConfirmationFormComponent,
    FormationFormComponent,
    PortailappelformComponent,
    FormAppelImprovedCdpComponent,
    FormMultiAppelCdpComponent,
    BootcampConfirmationComponent,
    ActivityAttendanceComponent,

    // AgendaComponent,
    // AppelsComponent,
    // BibliothequeComponent,
    // ELearningComponent,
    // HomeComponent,
    // ProfilComponent,
    // CardFormComponent,
    // SoumissionsComponent,
    // TableauBordComponent,
    // EditPasswordComponent,
    // EditProfilComponent,
    // FormProfilComponent,
    // SoumissionTableComponent,

    // Agenda2Component,
    // Appels2Component,
    // Bibliotheque2Component,
    // ELearning2Component,
    // Home2Component,
    // Profil2Component,
    // Soumissions2Component,
    // TableauBord2Component,
    // CardForm2Component,
    // EditPassword2Component,
    // EditProfil2Component,
    // FormProfil2Component,
    // SoumissionTable2Component,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    AuthModule,
    UtilisateursModule,
    SharedModule,
    // MainLayoutModule,
    AppelsModule,
    AgendaModule,
    BibliothequeModule,
    ELearningModule,
    CommonModule,
    MatCardModule,
    BrowserAnimationsModule,
    MatButtonToggleModule,
    MatDialogModule,
    FormsModule,
    ReactiveFormsModule,
    MatRadioModule,
    MatCheckboxModule,
    KeycloakAngularModule,
    BrowserModule,
    MatPaginatorModule,
  ],
  providers: [
    { provide: LocationStrategy, useClass: HashLocationStrategy },
    { provide: LOCALE_ID, useValue: 'fr-FR' },
    {
      provide: APP_INITIALIZER,
      useFactory: initializer,
      deps: [KeycloakService],
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: RequestInterceptorService,
      multi: true,
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {
  constructor() {
    registerLocaleData(fr.default);
  }
}
